import { NS, type MissionCard, type NamespaceTuple } from '@ownyou/shared-types';

export interface MissionPersistenceStore {
  put<T>(namespace: NamespaceTuple, key: string, value: T): Promise<void>;
}

export interface PersistWorkerMissionsResult {
  namespace: NamespaceTuple;
  persistedCount: number;
  persistedTotalCount: number;
}

export async function persistWorkerMissions(input: {
  store: MissionPersistenceStore;
  userId: string;
  missions: MissionCard[];
  fromIndex: number;
  now?: () => number;
}): Promise<PersistWorkerMissionsResult> {
  const namespace = NS.missionCards(input.userId);
  const newMissions = input.missions.slice(input.fromIndex);
  const now = input.now ?? Date.now;

  for (const mission of newMissions) {
    await input.store.put(namespace, mission.id, {
      ...mission,
      createdAt: typeof mission.createdAt === 'number'
        ? mission.createdAt
        : now(),
    });
  }

  return {
    namespace,
    persistedCount: newMissions.length,
    persistedTotalCount: input.missions.length,
  };
}
